import { render } from "./UserNewComponent.vue?vue&type=template&id=3fce107f&scoped=true"
import script from "./UserNewComponent.vue?vue&type=script&lang=js"
export * from "./UserNewComponent.vue?vue&type=script&lang=js"

import "./UserNewComponent.vue?vue&type=style&index=0&id=3fce107f&scoped=true&lang=css"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fce107f"]])

export default __exports__